/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CleanUpControllerService {

  /**
   * It will execute the cleanup of temporary generated user files and return a list containing them
   * @returns string List of deleted files
   * @throws ApiError
   */
  public static cleanUpUserFiles(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/cleanup',
    });
  }

}
